import { ApiDomainPaths } from '@/enums/apiDomainPaths';

export const enum AuthApiPaths {
  SIGN_IN = ApiDomainPaths.ACCOUNT + '/login',
  OTP_SIGN_IN = ApiDomainPaths.ACCOUNT + '/login-otp',
  FORGOT_USERNAME = ApiDomainPaths.ACCOUNT + '/forgot-username',
  FORGOT_PASSWORD = ApiDomainPaths.ACCOUNT + '/forgot-password',
  UPDATE_PASSWORD = ApiDomainPaths.ACCOUNT + '/change-password',
  LOGIN_CONFIGURATION = ApiDomainPaths.CONFIGURATION + '/login-configuration',
  REFRESH = ApiDomainPaths.ACCOUNT + '/refresh-token',
}
